/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "door-open-1f0959d9--sprite",
  "use": "door-open-1f0959d9--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"door-open-1f0959d9--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><path d=\"M199.326,24.621h-2.54v-.68a1.032,1.032,0,0,0-.04-.3,1.071,1.071,0,0,0-1.32-.73l-4.91,1.37a2.142,2.142,0,0,0-1.56,2.06v9.98a2.142,2.142,0,0,0,1.56,2.06l4.91,1.37a1.032,1.032,0,0,0,.3.04,1.063,1.063,0,0,0,1.06-1.07v-.68h2.54a2,2,0,0,0,2-2v-9.42A2,2,0,0,0,199.326,24.621Zm-4.87,7.47a.76.76,0,1,1,.75-.76A.76.76,0,0,1,194.456,32.091Zm4.87,3.95h-2.54v-9.42h2.54Z\" transform=\"translate(-176.957 -12.871)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
